import React, { useContext } from "react";
import PedidosReducer from "./PedidosReducer";
import PedidosContext from "./PedidosContext";
import MethodGet, { MethodPost } from "../../config/Service";
import headerConfig from "../../config/imageHeaders";
import AuthContext from "../auth/AuthContext";
import {
  GET_ALL_ORDERS_COMPLETED_USER,
  GET_ALL_ORDERS_PENDING_USER,
  GET_ORDER_INVOICED,
  PEDIDOS_CANCELADOS,
  PEDIDOS_ENVIADOS,
  PEDIDOS_EN_PREPARACION,
  PEDIDOS_PENDIENTES_DE_PAGO,
  STORE_ORDER,
  UPLOAD_TICKET,
  VALIDANDO_PAGO_PEDIDO,
  types,
} from "../../types";
import { useReducer } from "react";
import Swal from "sweetalert2";
const PedidosState = ({ children }) => {
  const initialState = {
    orders_client: [],
    ErrorsApi: [],
    success: false,
  };
  const { updateUsuario } = useContext(AuthContext);
  const [state, dispatch] = useReducer(PedidosReducer, initialState);
  const GetPedidosEnviados = () => {
    let url = "/distribucion/enviados";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: PEDIDOS_ENVIADOS,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetPedidosEnPreparacion = () => {
    let url = "/distribucion/preparando";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: PEDIDOS_EN_PREPARACION,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetPedidosPendientesDePago = () => {
    let url = "/distribucion/sinPagos";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: PEDIDOS_PENDIENTES_DE_PAGO,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetPedidosCancelados = () => {
    let url = "/distribucion/cancelados";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: PEDIDOS_CANCELADOS,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetValidandoPago = () => {
    let url = "/distribucion/validandoPago";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: VALIDANDO_PAGO_PEDIDO,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetOrderInvoiced = () => {
    let url = "/distribucion/SalesBillingWeb";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ORDER_INVOICED,
          payload: res.data.billings,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetAllOrdersPendingUser = () => {
    let url = `/distribucion/clientsales`;
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_ORDERS_PENDING_USER,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetAllOrdersCompletedUser = () => {
    let url = `/distribucion/finalizedsales`;
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_ORDERS_COMPLETED_USER,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const UploadTicket = (data) => {
    let url = "/distribucion/Payments";
    Swal.fire({
      title: "Subiendo imagen...!",
      showConfirmButton: false,
      showLoading: true,
    });
    Swal.showLoading();
    const formData = new FormData();
    formData.append("id_sale", data.id_sale);
    formData.append("reference", data.reference);
    formData.append("amount", data.amount);
    formData.append("image", data.image);
    MethodPost(url, formData, { headerConfig })
      .then((res) => {
        dispatch({
          type: UPLOAD_TICKET,
          payload: res.data,
        });
        Swal.fire({
          title: "Agregado",
          text: "El comprobante se ha cargado de manera correcta!",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      })
      .catch((error) => {
        Swal.fire({
          title: "¡Atención!",
          icon: "warning",
          timer: 1500,
          showConfirmButton: false,
          text: error.response.data.message,
        });
        console.log(error);
      });
  };

  const storeOrder = async (data) => {
    let url = "/distribucion/Sales";
    try {
      Swal.fire({
        title: "Creando orden...",
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      const response = await MethodPost(url, data); // Método de POST

      if (response.status === 200) {
        Swal.fire({
          title: "¡Éxito!",
          text: "Tu compra se ha realizado con éxito. Ahora sube tu comprobante de pago.",
          icon: "success",
          timer: 3500,
          showConfirmButton: false,
        });
        updateUsuario(response.data.client);
      }
    } catch (error) {
      const errorMsg =
        error.response?.data || "Ocurrió un error al procesar tu orden.";
      Swal.fire({
        title: "Error",
        text: errorMsg,
        icon: "error",
        timer: 3000,
        showConfirmButton: true,
      });
    }
  };

  return (
    <PedidosContext.Provider
      value={{
        orders_client: state.orders_client,
        ErrorsApi: state.ErrorsApi,
        success: state.success,
        GetAllOrdersPendingUser,
        GetAllOrdersCompletedUser,
        UploadTicket,
        GetPedidosCancelados,
        GetPedidosEnviados,
        GetPedidosEnPreparacion,
        GetValidandoPago,
        GetPedidosPendientesDePago,
        storeOrder,
        GetOrderInvoiced,
      }}
    >
      {children}
    </PedidosContext.Provider>
  );
};

export default PedidosState;
